<script lang="ts">
    export let value: number|undefined = undefined;
    const setIndex = (v: number) => () => value = v;
</script>

<style>
    div.score {
        display: flex;
        justify-content: space-between;
    }
    div.score > div {
        flex: 1;
        height: 50px;
        cursor: pointer;
        border-radius: 5px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        transition: background-color .5s;
    }
    div.score > div:not(:first-child) {
        margin-left: 1em;
    }
    div.score > div:not(.active):not(:hover) {
        background-color: rgba(0,0,0, .5);
    }
    .s1 {
        background-color: rgb(255,0,0);
    }
    .s2 {
        background-color: rgb(200,50,0);
    }
    .s3 {
        background-color: rgb(150,100,0);
    }
    .s4 {
        background-color: rgb(100,150,0);
    }
    .s5 {
        background-color: rgb(0,255,0);
    }

</style>
<div class="score">
    {#each [1,2,3,4,5] as num}
        <div on:click={setIndex(num)} class={`s${num} ${num === value ? 'active' : ''}`}>{num}</div>
	{/each}
</div>